import { render, staticRenderFns } from "./TableFormTmpl.vue?vue&type=template&id=44d3d494&scoped=true&"
import script from "./TableFormTmpl.vue?vue&type=script&lang=js&"
export * from "./TableFormTmpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d3d494",
  null
  
)

export default component.exports